import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/Auth";

const FirstSection = () => {
  const navigate = useNavigate();
  const { userCheck } = useAuth();

  const goToMyProfile = () => {
    userCheck(() => {
      navigate(`/edit-profile`);
    });
  };

  const goToCommunication = () => {
    userCheck(() => {
      navigate(`/communication`);
    });
  };

  return (
    <div className="card shadow-xss w-100 border-0 p-4 mb-3">
      <div className="card-body align-items-center p-0">
        <p className="text-current m-0">
          <strong>Step 1 of 6</strong>
        </p>
        <ul className="m-0 p-0 step-one-points">
          <li>
            <strong>Domestic and International Contests</strong> require{" "}
            <strong>Premium Membership</strong>. Free Members can upgrade when
            selecting a contest in Step 2.
          </li>
          <li>
            <strong>General Events</strong> include seminars and posing classes,
            are open to both{" "}
            <strong>Free Members and Premium Members</strong>.
          </li>
          <li>
            Ensure personal details in{" "}
            <a className="text-current cursor-pointer bold" onClick={goToMyProfile}>
              My Profile
            </a>{" "}
            are up to date before registering.
          </li>
        </ul>
        {/* <p className="m-0">
          Please ensure your{" "}
          <a className="text-current cursor-pointer" onClick={goToCommunication}>Communication Preferences</a> are set to
          receive event updates from iCompete
        </p> */}
      </div>
    </div>
  );
};

export default FirstSection;
